export class HttpError extends Error {
  constructor(
    public readonly status: number,
    public readonly body = '',
  ) {
    super(`HTTP ${status}${body ? `: ${body}` : ''}`);
  }
}

export async function postJson<T>(url: string, body: unknown, init?: RequestInit): Promise<T> {
  const headers = new Headers(init?.headers);
  headers.set('content-type', 'application/json');

  const response = await fetch(url, {
    ...init,
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const text = await response.text().catch(() => '');
    throw new HttpError(response.status, text);
  }

  const contentType = response.headers.get('content-type') ?? '';
  if (response.status === 204 || !contentType.includes('application/json')) {
    return undefined as T;
  }

  return response.json() as Promise<T>;
}
